import React from "react";

function Gallery() {
  const galleryItems = [
    {
      img: "img/portfolio/gallery-1.jpg",
      subtitle: "Empowering Rural Livelihoods:",
      title: "Women participating in sustainable livestock rearing",
    },
    {
      img: "img/portfolio/gallery-2.jpg",
      subtitle: "Restoring Vision, Restoring Hope:",
      title: "Providing essential eye screenings",
    },
    {
      img: "img/portfolio/gallery-3.jpg",
      subtitle: "Expressing Through Color:",
      title: "Tribal Marang Buru students with creative skills",
    },
    {
      img: "img/portfolio/gallery-4.jpg",
      subtitle: "Collective Action:",
      title: "Women participating in hands-on training for eco-friendly initiatives",
    },
    {
      img: "img/portfolio/gallery-5.jpg",
      subtitle: "Nutrition at the Doorstep:",
      title: "Promoting food security through the development of Nature positive farming",
    },
    {
      img: "img/portfolio/gallery-6.jpg",
      subtitle: "Building Champions on and off the Field:",
      title: "Promoting physical health, discipline, and teamwork through our youth sports",
    }
  ];

  return (
    <>
      {/* Page Title Section */}
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{ backgroundImage: 'url("/img/banner/banner-gallery.jpg")' }}
      >
        <div className="container">
          <div className="row position-relative z-index-9">
            <div className="col-md-12">
              <h1>Gallery</h1>
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>Gallery</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section>
        <div className="container">
          <div className="row portfolio-gallery-isotope mt-n4">
            {galleryItems.map((item, index) => (
              <div
                className="col-md-6 col-lg-4 mt-4 wow fadeInUp"
                data-wow-delay="100ms"
                data-src={item.img}
                data-sub-html={`<h4 class='text-white'>Business Consultation #01</h4><p>Business</p>`}
                key={index}
              >
                <div className="portfolio-style02 position-relative">
                  <div className="img-hover border-radius-10">
                    <img
                      src={item.img}
                      alt={item.title}
                      className="border-radius-10"
                    />
                  </div>
                  <div className="content">
                    <div className="pe-3">
                      <span className="d-block mb-1 text-primary font-weight-500">
                        {item.subtitle}
                      </span>
                      <h3 className="h5 mb-0">
                        {item.title}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>
    </>
  );
}

export default Gallery;